import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import classnames from 'classnames';

import { MILogo } from './../Icons';

const Curtain = ({ branding, handler, title }) => {
  const [isSlidedUp, setIsSlidedUp] = useState(false);
  const [curtainRef, isCurtainInView] = useInView({
    threshold: 0.8,
    triggerOnce: true,
  });

  useEffect(() => {
    if (isCurtainInView) {
      setTimeout(() => {
        setIsSlidedUp(true);
      }, 1000);
    }
  }, [isCurtainInView]);

  useEffect(() => {
    if (isSlidedUp && handler && isCurtainInView) {
      handler();
    }
  }, [isSlidedUp]);

  return (
    <div className={classnames('curtain', { 'curtain--slided-up': isSlidedUp })} ref={curtainRef}>
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <div className='curtain__container'>
              {branding && (
                <div className='curtain__branding'>
                  <MILogo className={'curtain__logo'} />
                </div>
              )}
              {title && <div className='curtain__title'>{title}</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Curtain.propTypes = {
  branding: PropTypes.bool,
  handler: PropTypes.func,
  title: PropTypes.string,
};

export default Curtain;
